export default "__VITE_ASSET__Pg72EUct__"